import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './baseService.service';
import { Observable, BehaviorSubject } from 'node_modules/rxjs';
import { UserModel } from '../../models/user.model';
import { YMUserModel } from '../../models/user.model';
import { map } from 'node_modules/rxjs/operators';
import { LoginComponent } from '@src/app/components/login/login.component';
import { LoginModel } from '@src/models/login.model';
import { ShortUserModel } from '../../models/shortUser.model';

@Injectable({providedIn: 'root'})
export class UserService extends BaseService {

    private currentUserSubject: BehaviorSubject<UserModel>;
    public currentUser: Observable<UserModel>;
    private systemUserSubject: BehaviorSubject<LoginModel>;
    public systemUser: Observable<LoginModel>;
    constructor(private http: HttpClient) {
        super();
        this.currentUserSubject = new BehaviorSubject<UserModel>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.systemUserSubject = new BehaviorSubject<LoginModel>(JSON.parse(sessionStorage.getItem('systemUser')));
        this.systemUser = this.systemUserSubject.asObservable();
     }

    sendData(model: UserModel) {
        return this.http.post<UserModel>(`${environment.apiUrl}/user/GetUserData`, model)
        .pipe(map(user => {
            sessionStorage.setItem('token', user.token);
            sessionStorage.setItem('currentUser', JSON.stringify(user)),
            this.currentUserSubject.next(user);
            return user;
        }));
    }
    // sendDataShortModel(model: ShortUserModel) {
    //     console.log(model);
    //     return this.http.post<UserModel>(`${environment.apiUrl}/user/GetShortUserData`, model)
    //     .pipe(map(user => {
    //         sessionStorage.setItem('token', user.token);
    //         sessionStorage.setItem('currentUser', JSON.stringify(user)),
    //         this.currentUserSubject.next(user);
    //         return user;
    //     }));
    // }
    sendDataFromYardManagement(model:UserModel) {
        return this.http.post<YMUserModel>(`${environment.apiUrl}/ym/SetUserTraining`, model)
        .pipe(map(user => {
            sessionStorage.setItem('token', user.token);
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            sessionStorage.setItem(environment.sessionIsYMUser, 'true');
            sessionStorage.setItem(environment.sessionSelectedExam, user.trainingTypeId.toString());
            sessionStorage.setItem(environment.sessionSelectedTrainingFile, user.trainingDocument);
            sessionStorage.setItem(environment.sessionSelectedTrainingDesc, user.description);
            //sessionStorage.setItem(environment.requestIdentifier, user.identifier);
            this.currentUserSubject.next(user);
            return user;
        }));
    }

    login(model: LoginModel) {
        return this.http.post<LoginModel>(`${environment.apiUrl}/user/login`, model)
        .pipe(map(user => {
            sessionStorage.setItem('token', user.token);
            sessionStorage.setItem('systemUser', JSON.stringify(user)),
            this.systemUserSubject.next(user);
            return user;
        }));
    }

    logout() {
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        sessionStorage.removeItem('systemUser');
        this.systemUserSubject.next(null);
        sessionStorage.removeItem('token');
    }

    public get currentUserValue() {
        return this.currentUserSubject.asObservable();
    }

    public get systemUserValue() {
        return this.systemUserSubject.asObservable();
    }
}